export function addReturnUrl(url: string, returnUrl: string): string {
  if (!returnUrl) {
    return url
  }

  const separator = url.includes('?') ? '&' : '?'

  return `${url}${separator}returnurl=${returnUrl}`
}
